import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  font-family: Inter, sans-serif;
  color: ${(props) => props.theme.colors.greys.darkest};
`;

export const TagsInputContainer = styled.div`
  min-height: 40px;
  width: 100%;

  .react-tagsinput {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;

    min-height: 40px;
    width: 100%;
    padding: 8px 16px;
    gap: 6px;

    cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'text')};
    background-color: ${(props) =>
      props.isDisabled ? props.theme.colors.greys.light : props.theme.colors.greys.lightest};

    border: 1px solid ${(props) => props.theme.colors.greys.light};
    border-radius: 8px;

    overflow: hidden;
  }

  .react-tagsinput > span {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    width: 100%;
  }

  .react-tagsinput-tag {
    display: flex;
    align-items: center;

    height: 24px;
    margin: 0;
    padding: 0px 8px;

    background-color: ${(props) =>
      props.isDisabled ? props.theme.colors.greys.medium : props.theme.colors.greys.lighter};
    border: 1px solid ${(props) => props.theme.colors.greys.light};
    border-radius: 4px;

    color: ${(props) => props.theme.colors.greys.darkest};
    font: ${(props) => props.theme.fonts.textSmallHeight16};
  }

  .react-tagsinput-custom {
    display: flex;
    align-items: center;

    min-width: 120px;
    height: 24px;

    background-color: transparent;
    border: none;

    color: ${(props) => props.theme.colors.greys.darkest};
    font: ${(props) => props.theme.fonts.textSmallHeight16};
    cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'text')};
  }

  .react-tagsinput-remove {
    cursor: pointer;
    padding-left: 6px;
  }

  .react-tagsinput-tag a::before {
    color: ${(props) => props.theme.colors.greys.darkest};
    text-decoration: none;
    font-size: 17px;
    content: ' ×';
  }

  .react-tagsinput-tag a:hover {
    color: ${(props) => props.theme.colors.greys.darkest};
    text-decoration: none;
  }

  .react-tagsinput-tag a:active,
  .react-tagsinput-tag a:visited {
    color: ${(props) => props.theme.colors.greys.darkest};
    text-decoration: none;
  }
`;
